export default __webpack_public_path__ + "static/media/separator-guides.9474f054.svg";